import { IRegisterForm } from '../../../../../interface/Auth/frontend';

enum RuPass {
	Series = 4,
	Number = 6,
}

export enum PassportType {
	Ru = 1,
	Foreign = 2,
}

export enum AgreementType {
	personalDataProcessing,
	confidentialPolicy,
}

export const checkPhone = (phone: string | null) => {
	return (phone?.length || 0) < 1;
};

export const checkMail = (mail: string | null) => {
	return (mail?.length || 0) < 1;
};

export const checkPhoneSubmit = (phoneSubmit: boolean) => {
	return !phoneSubmit;
};

export const checkMailSubmit = (mailSubmit: boolean) => {
	return !mailSubmit;
};

export const checkName = (registerForm: IRegisterForm) => {
	const { name } = registerForm;
	return name.length < 1;
};

export const checkLastName = (registerForm: IRegisterForm) => {
	const { surname } = registerForm;
	return surname.length < 1;
};

export const checkBirthDate = (registerForm: IRegisterForm) => {
	const { birthDate } = registerForm;
	return birthDate === null;
};

export const checkRuPassport = (registerForm: IRegisterForm) => {
	const { citizenshipId, passportSeries, passportNumber } = registerForm;
	return citizenshipId === PassportType.Ru
		? passportSeries.length !== RuPass.Series || passportNumber.length !== RuPass.Number
		: false;
};

export const checkForeignPassport = (registerForm: IRegisterForm) => {
	const { citizenshipId, passportNumber } = registerForm;
	return citizenshipId === PassportType.Foreign ? passportNumber.length < 1 : false;
};

export const checkAgreement = (agreementGiven: boolean) => {
	return !agreementGiven;
};
